import React from 'react';
import ContactPage from './ContactPage/ContactPage';

const Contact = () => {
    return (
        <div>
            <ContactPage />
        </div>
    );
};

export default Contact;
